import { render, staticRenderFns } from "./textCell.vue?vue&type=template&id=f2e25236&scoped=true&"
import script from "./textCell.vue?vue&type=script&lang=js&"
export * from "./textCell.vue?vue&type=script&lang=js&"
import style0 from "./textCell.vue?vue&type=style&index=0&id=f2e25236&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e25236",
  null
  
)

export default component.exports